<template>
  <section class="py-5 bg-white text-dark">
    <div class="container">
      <h1 class="mb-4 text-primary fw-bold">
        <i class="fas fa-coins me-2"></i> Noile praguri pentru achiziții publice
      </h1>

      <p>
        Începând cu <strong>12 septembrie 2022</strong>, Legea <strong>208/2022</strong> a modificat pragurile valorice relevante pentru aplicarea procedurilor din <strong>Legea 98/2016</strong>.
      </p>

      <!-- Praguri -->
      <h5 class="mt-4 fw-semibold text-primary">
        <i class="fas fa-chart-line me-2"></i> Praguri valorice (fără TVA)
      </h5>
      <ul class="mb-4">
        <li><i class="fas fa-hammer me-2 text-primary"></i><strong>26.093.012 lei</strong> – lucrări</li>
        <li><i class="fas fa-boxes me-2 text-primary"></i><strong>678.748 lei</strong> – produse și servicii</li>
        <li><i class="fas fa-university me-2 text-primary"></i><strong>1.042.363 lei</strong> – produse/servicii autorități locale</li>
        <li><i class="fas fa-users-cog me-2 text-primary"></i><strong>3.636.150 lei</strong> – servicii sociale / anexa 2</li>
      </ul>

      <!-- Achiziții directe -->
      <h5 class="fw-semibold text-primary">
        <i class="fas fa-handshake me-2"></i> Achiziții directe
      </h5>
      <ul class="mb-4">
        <li><i class="fas fa-arrow-right me-2 text-primary"></i><strong>&lt; 270.120 lei</strong> – produse/servicii</li>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i><strong>&lt; 900.400 lei</strong> – lucrări</li>
        <li><i class="fas fa-arrow-right me-2 text-primary"></i><strong>&lt; 9.000 lei</strong> – plată directă fără ofertă</li>
      </ul>

      <!-- Obligații -->
      <h5 class="fw-semibold text-primary">
        <i class="fas fa-exclamation-circle me-2"></i> Obligații suplimentare
      </h5>
      <ul>
        <li><i class="fas fa-globe me-2 text-primary"></i>Publicare în SEAP / site propriu dacă valoarea > <strong>200.000 lei</strong></li>
        <li><i class="fas fa-users me-2 text-primary"></i>Consultare a <strong>3 operatori</strong> între 140.000 – 200.000 lei</li>
        <li><i class="fas fa-file-alt me-2 text-primary"></i>Raportare <strong>trimestrială în SEAP</strong></li>
      </ul>

      <p class="mt-4">
        Aceste praguri se aplică exclusiv <strong>procedurilor lansate după 12.09.2022</strong>. Legea 208/2022 completează Articolul 7 din Legea 98/2016.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NoilePraguri'
}
</script>
